/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import React, {useCallback} from 'react';
import isEqual from 'lodash.isequal';
import {Entity} from '@ion/core/src/types/entities';
import Chip from '@ion/dls/src/components/chip/Chip';
import {dlsColor} from '@ion/dls/src/theme/theme';

interface IdentifiersListType {
  data?: any[];
  entity?: Entity;
  boxStyle?: string;
  onTitleClick?: Function;
};

/**
 * The IdentifiersList component displays. This component is used to
 * display groups in chips.
 *
 * ```typescript
 *
 * import {IdentifiersList} from '@ion/applications/src/pages/IdentifiersList';
 *
 *  <IdentifiersList />
 *
 * ```
 */
const IdentifiersList = ({
  data,
  entity,
  boxStyle,
  onTitleClick
}: IdentifiersListType) => {
  const hasGroup = useCallback(() => {
    return isEqual(entity, Entity.group);
  }, [entity]);

  if (data?.length) {
    return (
      <>
        <div className={boxStyle}>
          {data?.map?.((item) => (
            <Chip label={item?.title}
              size={'large'}
              maxWidth={false}
              borderRadius={'56px'}
              labelColor={dlsColor('grey2')}
              onClick={hasGroup() ? onTitleClick(item) : null}
              hoverDefault
              showCustomDeleteIcon
              noTextTransform />
          ))}
        </div>
      </>
    );
  }
  return <div/>;
};

export default React.memo(IdentifiersList);
